import { render, staticRenderFns } from "./retail_outlets.vue?vue&type=template&id=f5094abe&"
import script from "./retail_outlets.vue?vue&type=script&lang=js&"
export * from "./retail_outlets.vue?vue&type=script&lang=js&"
import style0 from "./retail_outlets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports